export const isAdmin = (user) => user?.role === "admin";

export const isManagementUser = (user) => user?.isManagement === true;

export const getActiveRoles = (user) => {
  if (Array.isArray(user?.roles) && user.roles.length) {
    return user.roles;
  }
  if (user?.role) {
    return [user.role];
  }
  return [];
};

export const userHasRole = (user, roleSlug) =>
  getActiveRoles(user).includes(roleSlug);

export const isUnifiedAdmin = (user) => userHasRole(user, "unified-admin");
